import React from 'react';
import { useNotifications } from '../contexts/NotificationsContext';
import Notification from './Notification';

/**
 * Notification Container Component
 * Displays all notifications in a stack (top-right or custom position)
 * Place this component in your main App or Layout component
 */
const NotificationContainer = ({ position = 'top-right' }) => {
  const { notifications, removeNotification } = useNotifications();

  const positionClasses = {
    'top-right': 'top-4 right-4',
    'top-left': 'top-4 left-4',
    'top-center': 'top-4 left-1/2 transform -translate-x-1/2',
    'bottom-right': 'bottom-4 right-4',
    'bottom-left': 'bottom-4 left-4',
  };

  return (
    <div 
      className={`
        fixed ${positionClasses[position] || positionClasses['top-right']}
        z-50 space-y-3 max-w-sm w-full px-4
        pointer-events-none
      `}
    >
      {notifications.map(notification => (
        <div 
          key={notification.id}
          className="pointer-events-auto"
        >
          <Notification
            type={notification.type}
            message={notification.message}
            duration={notification.duration}
            onDismiss={() => removeNotification(notification.id)}
          />
        </div>
      ))}
    </div>
  );
};

export default NotificationContainer;
